package com.elan.edubridge.ui.member

import com.elan.edubridge.ui.shell.Router
import com.elan.edubridge.ui.shell.requireSession

/**
 * `/app/me` 하위 라우트 등록(계획 §5.2, C↔D 접점은 `Router.register`).
 *
 * 로그인 여부만 확인한다(`requireSession`) — 권한으로 더 좁히지 않는다. VIEWER가 아닌 세션(선생님·
 * 학원장 등)이 `/app/me`로 직접 들어와도 자기 계정 보기로 정상 동작해야 한다(가이드 §3.3, Done-when
 * 요건). 스태프 콘솔 진입 게이트(`MembershipPolicy.isStaff`)는 여기 관여하지 않는다.
 *
 * Main.kt 배선(호출 시점·`/app/{academyId}/{section}` 와일드카드와의 등록 순서)은 매니저가 통합
 * 단계에서 붙인다 — 이 lane은 Main.kt를 건드리지 않는다(작업 지시 범위).
 */
object MemberRoutes {
    fun register() {
        Router.register("/app/me", requireSession { session, _ -> MyTodayPage.render(session) })
        Router.register("/app/me/schedule", requireSession { session, _ -> MySchedulePage.render(session) })
        Router.register("/app/me/notices", requireSession { session, _ -> MyNoticesPage.render(session) })
        Router.register("/app/me/board", requireSession { session, _ -> MyBoardPage.render(session) })
        Router.register("/app/me/assignments", requireSession { session, _ -> MyAssignmentsPage.render(session) })
        Router.register("/app/me/notifications", requireSession { session, _ -> NotificationInboxPage.render(session) })
        Router.register("/app/me/settings", requireSession { session, _ -> MySettingsPage.render(session) })
        Router.register("/app/me/account-deletion", requireSession { session, _ -> AccountDeletionPage.render(session) })
        Router.register("/app/me/academy-application", requireSession { session, _ -> AcademyApplicationPage.render(session) })
    }
}
